import { TConfig, TConfigInput, TGetAddOns } from '@@/auto/interfaces';
import { excludeFalse } from '@@/auto/utils/excludeFalse';

import { AUTO_DISCOUNTS } from '../../autoDiscounts';

const ToggleAZConfig: DeepPartial<TConfigInput> = {
  auto: {
    addOns: {
      getAddOns: ({ userAction }: Parameters<TGetAddOns>[0]) =>
        excludeFalse([
          'towing_road_services',
          'temporary_ride',
          'side_hustle',
          'gap',
          'oem_parts',
          'new_car_replacement',
          'glass',
          userAction === 'editing-addons' && 'pet_passenger',
        ] as const),
    },
  },
  autoDiscounts: [
    AUTO_DISCOUNTS.distantStudent,
    AUTO_DISCOUNTS.goodStudent,
    AUTO_DISCOUNTS.homeowner,
    AUTO_DISCOUNTS.multiCar,
    AUTO_DISCOUNTS.multiPolicy,
    AUTO_DISCOUNTS.safeDriving,
    AUTO_DISCOUNTS.teenDriver,
  ],
  visibleCoverages: (visibleCoverages: TConfig['visibleCoverages']) => {
    return {
      ...visibleCoverages,
      protectionCoverages: [
        ...visibleCoverages.protectionCoverages,
        {
          label: 'Underinsured Motorist Bodily Injury',
          key: 'underinsured_motorist_bodily_injury_limit',
        },
        {
          label: 'Pet Passenger',
          key: 'pet_passenger',
        },
      ],
    };
  },
  initialCoverageValues: {
    gap: 'false',
    temporary_ride: 'null',
    side_hustle: 'false',
    glass: 'false',
  },
};
export default ToggleAZConfig;
